<template>
  <div
    class="survey-question"
    :class="{
      'requires-response': question.requiresResponse,
      'has-trigger-option': hasTriggerOption,
      'triggers-selected': triggersSelected
    }"
  >
    <div class="question-header">
      <span>
        <span v-if="!hasTriggerOption">{{ questionNumber }}.</span> {{ question.title }}
        <span v-if="question.multipleResponses" class="multiple-hint">(Multiple Answers Possible)</span>
      </span>

      <div class="question-actions">
        <button
          v-if="question.imageBase64"
          class="btn-icon"
          @click="$emit('show-image', question.imageBase64)"
          title="View Image"
        >
          <svg width="20" height="20" viewBox="0 0 24 24">
            <path fill="currentColor" d="M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 11.5V13H9v2.5L5.5 12 9 8.5V11h6V8.5l3.5 3.5-3.5 3.5z"/>
          </svg>
        </button>

        <button
          v-if="question.information"
          class="btn-icon"
          @click="$emit('show-information', question)"
          title="More Information"
        >
          <svg width="20" height="20" viewBox="0 0 24 24">
            <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
          </svg>
        </button>
      </div>
    </div>

    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'QuestionCard',
  props: {
    question: { type: Object, required: true },
    questionNumber: { type: Number, required: true },

    triggersSelected: { type: Boolean, default: false },
    hasTriggerOption: { type: Boolean, default: false },
  },
  emits: ['show-image', 'show-information'],
};
</script>

<style lang="scss" scoped>
.survey-question {
  position: relative;
  background: white;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;

  &:hover {
    box-shadow: 0 4px 6px rgba(0,0,0,0.07);
  }

  &.has-trigger-option {
    .question-header {
      background: linear-gradient(135deg, #059669, #10B981);
    }
  }



  &.has-trigger-option::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0; bottom: 0;
    width: 6px;
    background: linear-gradient(180deg, #F59E0B, #FCD34D);
    opacity: 0.9;
  }

  &.triggers-selected {
    border-color: #10B981; 
    box-shadow: 0 0 0 2px rgba(16,185,129,0.15);

    .question-header {
      background: linear-gradient(135deg, #059669, #10B981);
    }
  }

  &.requires-response {
    border: 1px solid #EF4444;
    box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.2);

    .question-header {
      background: linear-gradient(135deg, #EF4444, #DC2626);
    }
  }
}

.question-header {
  background: linear-gradient(135deg, #013B82, #0A2D5C);
  color: white;
  padding: 14px 16px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;

  span {
    flex: 1;
    text-align: left;
    padding-right: 10px;

    .multiple-hint {
      font-size: 12px;
      font-weight: normal;
      opacity: 0.9;
      margin-left: 5px;
    }
  }

  .question-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
  }

  .btn-icon {
    background: transparent;
    border: none;
    color: white;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: background-color 0.2s;
    padding: 0;

    &:hover {
      background-color: rgba(255, 255, 255, 0.2);
    }
  }
}
</style>
